export default __webpack_public_path__ + "static/media/Shield of Amra.f7753333.jpg";